import $ from 'jquery'

$(document).ready(function () {
    $('select').wrap('<div class="selection-wrapper">');

    // Listen for the form submission
    $('form.filter').submit(function(event) {
        // Prevent the default form submission
        event.preventDefault();

        // Get the selected term from the dropdown
        var selectedTerm = $('select[name="sign-filter"]').val();

        // Get the current query string parameters
        var queryParams = new URLSearchParams(window.location.search);

        // Update or set the 'sign-filter' parameter
        queryParams.set('sign-filter', selectedTerm);

        // Ensure we are on the first page of results
        queryParams.set('paged', 1);

        // Redirect to the updated URL
        var redirectUrl = window.location.pathname + '?' + queryParams.toString();
        window.location.href = redirectUrl;
    });
});


// WEBPACK FOOTER //
// ./resources/assets/js/partials/inputs.js